@if (isMobile) {
    <ins-static-text
        #inputRef
        [clearButton]="clearButton"
        [placeholder]="placeholder"
        [sklValidate]="validationKey"
        [disabled]="disabled"
        [value]="textValue"
        (click)="handleClick($event)">
    </ins-static-text>
} @else {
    <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
}

<ng-template #inputTemplate>
    @if (multiline) {
        <ins-textarea
            #inputRef
            [clearButton]="clearButton"
            [multiline]="true"
            [placeholder]="placeholder"
            [disabled]="disabled"
            [sklValidate]="validationKey"
            [ngModel]="textValue"
            (click)="handleClick($event)"
            (keyup)="textChange($event)"
            (insInput)="handleInput($event)">
        </ins-textarea>
    } @else {
        <ins-input
            #inputRef
            [clearButton]="clearButton"
            [placeholder]="placeholder"
            [sklValidate]="validationKey"
            [ngModel]="textValue"
            [disabled]="disabled"
            (click)="handleClick($event)"
            (keyup)="textChange($event)"
            (insInput)="handleInput($event)">
        </ins-input>
    }
</ng-template>

<!-- Templates -->
<ng-template #listTemplate>
    <ins-list
        class="list-template"
        #listRef
        [autoSearch]='false'
        (insOptionSelect)="handleSelection($event)">

        <div slot="header">
            @if (isMobile) {
                <div class="list-search">
                    <skl-icon name="angle-left" (click)="close()"></skl-icon>
                    <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
                </div>
            }
        </div>

        @if (hasData$ | async) {
            <ng-content></ng-content>

            @if (canLoad$ | async) {
                <skl-loader class="dynamic-list-status" (sklLoader)="handleLoad($event)"></skl-loader>
            }
        } @else {
            <div
                class="dynamic-list-status lack-of-data">
                <div class="dynamic-list-status--item">
                    <span class="align--form-left align--form-right">{{ 'ui.quick-list.lack-of-data' | translate }}</span>
                </div>
            </div>
        }

        <div slot="footer">
            <div #ref (click)="footerClicked()">
                <ng-content select="[slot=footer]"></ng-content>
            </div>
        </div>
    </ins-list>

</ng-template>
